<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else>
            <template v-slot:header>
                <h5>IMEI Database</h5>
            </template>
            <div class="search-wrapper d-flex align-items-center justify-content-between">
                <b-form-group label="Filter" label-for="filterInput" class="form-inline form-group-wrapper mb-3">
                    <div class="d-flex search-input-wrapper">
                        <b-form-input class="mx-2" v-model="filter.filterTipe" name="filterTipe" type="search"
                            placeholder="Nama Tipe" @keyup.enter="onFilter"></b-form-input>
                        <b-form-input class="mx-2" v-model="filter.filterImei" name="filterImei" type="search"
                            placeholder="No. IMEI" @keyup.enter="onFilter"></b-form-input>

                        <b-form-select v-model="filter.filterSpek" id="filterSpek" name="filterSpek" :options="options"
                            value-field="value" text-field="text">
                        </b-form-select>

                        <b-button class="mx-2" variant="pgiBtn" :disabled="isBusy" name="searchTableBtn" @click="onFilter">
                            <i class="fa fa-search"></i>
                        </b-button>
                        <b-button variant="pgiBtn" name="resetTableBtn" :disabled="isBusy" @click="onReset">Reset</b-button>
                    </div>
                </b-form-group>
                <div>
                    <b-button v-if="menu.includes('EIR')" class="mb-3" variant="pgiBtn" name="promoAddBtn"
                        @click="inputImei">
                        <i class="fa fa-plus mr-2"></i>
                        Input IMEI
                    </b-button>
                    <b-button v-if="menu.includes('EIR')" variant="pgiBtn" class="mx-2 mb-3 download-btn"
                        @click="$bvModal.show('modal-confirm-download')" :disabled="isBusy">
                        <i class="fa fa-download mr-2"></i>
                        Download Excel
                    </b-button>
                </div>
            </div>
            <b-table bordered hover show-empty :busy="isBusy" :items="imei" :fields="fields" :no-local-sorting="false"
                @sort-changed="sortingChanged" responsive class="mb-3">
                <template v-slot:table-busy>
                    <div class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong> Loading data...</strong>
                    </div>
                </template>
                <template v-slot:empty>
                    Tidak ada data IMEI.
                </template>
                <template v-slot:cell(spek)="row">
                    <b-badge v-if="row.item.spek == 2" variant="success">RESMI</b-badge>
                    <b-badge v-if="row.item.spek == 5" variant="danger">LN</b-badge>
                </template>
                <template v-slot:cell(createdAt)="row">
                    {{ $helper.changeDateFormat(row.item.createdAt) }}
                    {{ $helper.changeDateFormatGetHour(row.item.createdAt) }}
                </template>
                <template v-slot:cell(action)="row">
                    <b-button class="btn btn-sm mr-2" variant="danger" @click="modalDelete(row.item.id)">
                        <i class="fa fa-trash"></i>
                    </b-button>
                    <!-- <b-button class="btn btn-sm mr-2" variant="pgiBtn" @click="modalFoto(row.item.id)">
                        <i class="fa fa-eye"></i>
                    </b-button> -->
                    <b-button class="btn btn-sm" variant="primary" @click="detail(row.item.id)">
                        <i class="fa fa-eye"></i>
                    </b-button>
                </template>
            </b-table>

            <div class="pagination-wrapper d-flex align-items-center justify-content-between">
                <b-input-group prepend="Tampilkan" class="align-items-center tableShowItem">
                    <b-form-select v-model="filter.show" id="showItems" :options="PageOptions" @change="onLimitChange">
                        <template v-slot:first>
                            <b-form-select-option :value="null" disabled />
                        </template>
                    </b-form-select>
                    <span class="ml-2">{{ totalViewText }}</span>
                </b-input-group>
                <b-pagination class="mb-0" v-model="currentPage" :total-rows="rows" :per-page="perPage"
                    aria-controls="my-table" @input="onPageChange"></b-pagination>
            </div>
        </b-card>
        <b-modal id="modal-input-imei" title="Input IMEI" no-close-on-backdrop>
            <b-row>
                <b-col>
                    <b-form-group label="Jenis Barang">
                        <multiselect v-model="input.jenisBarang" :options="optElekJenis" :internal-search="true"
                            :allow-empty="false" deselect-label="" select-label="" label="name" track-by="id"
                            placeholder="-- Please select an option --" />
                    </b-form-group>

                    <b-form-group label="Merk Barang">
                        <multiselect v-model="input.merkBarang" :disabled="optElekMerk.length == 0" :options="optElekMerk"
                            :internal-search="true" :allow-empty="false" deselect-label="" select-label="" label="name"
                            track-by="id" placeholder="-- Please select an option --" />
                    </b-form-group>

                    <b-form-group label="Tipe Barang" id="gadaiTipeBarang" class="select-tipe-barang">
                        <multiselect id="gadaiTipeBarang" name="gadaiTipeBarang" v-model="input.tipeBarang"
                            :disabled="optElekTipe.length == 0" :options="optElekTipe" :internal-search="true"
                            :allow-empty="true" deselect-label="" select-label="" label="name" track-by="name"
                            placeholder="-- Please select an option --" />
                    </b-form-group>

                    <b-form-group label="No. IMEI / SN">
                        <b-row no-gutters>
                            <b-col>
                                <b-form-input v-model="input.noImei" name="gadaiNoImei" required></b-form-input>
                            </b-col>
                        </b-row>
                    </b-form-group>

                    <b-form-group label="Spek IMEI">
                        <b-form-select v-model="input.spek" :options="options"></b-form-select>
                    </b-form-group>

                </b-col>
            </b-row>
            <template v-slot:modal-footer="{ cancel }">
                <b-button variant="secondary" name="closeDetailBtn" @click="cancel()">
                    Tutup
                </b-button>
                <b-button variant="pgiBtn" :disabled="loading" name="closeDetailBtn" @click="submit()">
                    {{ loading ? 'Loading...' : 'Submit' }}
                </b-button>
            </template>
        </b-modal>

        <b-modal id="modal-foto" title="Foto IMEI Database" no-close-on-backdrop>
            <div class="foto-container" v-if="foto.length > 0">
                <span class="foto-item" v-for="(item, index) in foto" :key="index">
                    <a v-bind:href="$companyId == 'PGI' ? $baseFilePath + item.name : item.name" target="_blank">
                        <img width="130px" height="130px"
                            :src="$companyId == 'PGI' ? $baseFilePath + item.name : item.name">
                    </a>
                </span>
            </div>
            <div v-else>
                Tidak ada foto untuk entry database IMEI ini
            </div>
            <template v-slot:modal-footer="{ cancel }">
                <b-button variant="secondary" name="closeDetailBtn" @click="cancel()">
                    Tutup
                </b-button>
            </template>
        </b-modal>

        <ModalConfirm id="modal-delete-imei" title="Konfirmasi Hapus IMEI Database" :isSubmitting="loading"
            desc="Apakah anda yakin untuk hapus IMEI Database ini ?" @submit="onDelete" />


        <ModalConfirm id="modal-confirm-download" title="Confirm Download IMEI Database"
            desc="Apakah anda yakin untuk mendownload IMEI Database ini?" @submit="onDownloadOrder()" />
        <b-modal id="modal-download-imei" centered title="Download IMEI Database" hide-footer no-close-on-backdrop>
            <div class="text-center" v-if="loading == true">
                <b-spinner class="align-middle mb-4"></b-spinner>
                <p class="mb-0">Sedang memproses, mohon menunggu...</p>
            </div>
            <div class="show-btn-download" v-else>
                <p class="">
                    Silakan download dengan klik tombol dibawah ini :
                </p>
                <b-button variant="pgiBtn" class="mb-0 download-btn">
                    <a v-bind:href="$baseFilePath + filePathDownload" download>
                        <i class="fa fa-download mr-2"></i>
                        Download IMEI Database
                    </a>
                </b-button>
            </div>
        </b-modal>

        <b-modal id="modal-detail" title="Foto IMEI" no-close-on-backdrop>
            <div class="detail-data-wrapper mb-4">
                <MFotoPendukung :data="dataDetail" @fetchData="detail"
                    :hasAccess="hasAccess" />
            </div>
        </b-modal>
    </div>
</template>

<script>
import MFotoPendukung from './MFotoPendukung.vue'

export default {
    name: 'imei-database',
    components: {
        MFotoPendukung
    },
    data() {
        return {
            menu: localStorage.getItem('menuChildren'),
            initStatus: 0,
            isBusy: true,
            filter: {
                show: 10,
                filterImei: null,
                filterTipe: null,
                filterSpek: null,
                sortBy: null,
                sortDesc: null
            },

            hasAccess: (localStorage.getItem('menuChildren').includes("EIR")) ? true : false,
            filePathDownload: null,
            fields: [
                { key: "tipe", label: "Tipe Barang" },
                { key: "imei", label: "IMEI" },

                { key: "createdAt", label: "Ditambahkan Pada" },
                { key: "action", label: "Aksi" }
            ],
            statusPromo: [
                { id: 0, name: 'Pending' },
                { id: 1, name: 'Berjalan' },
                { id: 2, name: 'Selesai' },
            ],
            PageOptions: [
                { value: 10, text: '10' },
                { value: 20, text: '20' },
                { value: 30, text: '30' },
                { value: 40, text: '40' },
                { value: 50, text: '50' },
            ],

            input: {
                noImei: null,
                password: "",
                jenisBarang: { id: null, name: null },
                merkBarang: { id: null, name: null },
                tipeBarang: null,
                spek: null
            },

            options: [
                { value: null, text: '--- Spek IMEI ---' },
                { value: 2, text: 'IMEI Resmi' },
                { value: 5, text: 'IMEI LN' },
            ],
            optElekJenis: [],
            optElekMerk: [],
            optElekTipe: [],

            dataDetail: {},

            foto: [],
            imei: [],
            currentPage: 1,
            perPage: 10,
            rows: null,
            totalViewText: "",
            page: '',
            size: '',
            loading: false,
            query: ""
        }
    },
    methods: {

        //----------------- Fungsi Inisialisasi -----------------

        init() {
            this.initStatus = 0
            this.page = 0
            this.size = this.filter.show
            this.query = this.$helper.makeQuery(this.page, this.size)

            let getImei = this.$axios.get("imei-database/" + this.query).then(response => {
                this.imei = response.data.data
                this.updateTotalItem(response.data.total)
            })

            let getJenisElek = this.$axios.get("barang-jenis/elektronik").then(response => {
                this.optElekJenis = response.data
            })


            Promise.all([getImei, getJenisElek]).then(() => {
                this.initStatus = 1
                this.toggleBusy()
            })
                .catch(error => {
                    console.log(error)
                    this.initStatus = -1
                })
        },


        //----------------- Fungsi Ambil Data Promo -----------------

        getImei() {
            this.toggleBusy()
            this.imei = []

            if (this.filter.filterTipe != null) this.query = this.query + "&filterTipe=" + this.filter.filterTipe
            if (this.filter.filterImei != null) this.query = this.query + "&filterImei=" + this.filter.filterImei
            if (this.filter.filterSpek != null) this.query = this.query + "&filterSpek=" + this.filter.filterSpek

            this.$axios.get("imei-database/" + this.query).then(response => {
                this.imei = response.data.data
                this.toggleBusy()
                this.updateTotalItem(response.data.total)
                this.loading = false
            })
                .catch(error => {
                    console.log(error)
                    console.log(error.response.data.reason)
                    this.$helper.parseError(this, error)
                    this.toggleBusy()
                    this.loading = false
                })
        },


        //----------------- Fungsi Pagination, Sorting, dan loading -----------------

        onLimitChange() {
            this.size = this.filter.show
            this.perPage = this.filter.show
            this.currentPage = 1
            this.page = 0
            this.query = this.$helper.makeQuery(0, this.size)
            this.getImei()
        },

        onPageChange() {
            if (this.loading == false) {
                this.page = this.currentPage - 1
                this.query = this.$helper.makeQuery(this.page, this.size)
                this.getImei()
            }
        },

        sortingChanged(ctx) {
            if (ctx.sortBy == "persen") {
                this.filter.sortBy = "nominalPersen"
                this.filter.sortDesc = ctx.sortDesc
                this.onFilter()
            } else if (ctx.sortBy != "") {
                this.filter.sortBy = ctx.sortBy
                this.filter.sortDesc = ctx.sortDesc
                this.onFilter()
            }
        },

        onReset() {
            this.filter.filterTipe = null
            this.filter.filterImei = null
            this.filter.filterSpek = null
            this.currentPage = 1
            this.page = 0
            this.query = this.$helper.makeQuery(0, this.size)
            this.loading = true
            this.getImei()
        },

        onFilter() {
            this.page = 0
            this.currentPage = 1
            this.query = this.$helper.makeQuery(0, this.size)
            this.loading = true
            this.getImei()
        },


        //----------------- Fungsi Pindah Halaman dan Fungsi Lain -----------------

        toggleBusy() {
            if (this.isBusy == true) this.isBusy = false
            else this.isBusy = true
        },

        updateTotalItem(total) {
            let limit = null
            let prevLimit = null
            this.perPage = this.size
            this.rows = total
            prevLimit = this.page * this.size + 1
            limit = this.page * this.size + this.size
            if (limit > this.rows) limit = this.rows
            this.totalViewText = "Menampilkan " + prevLimit + " - " + limit + " dari " + this.rows + " entri"
        },

        inputImei() {
            this.input = {
                noImei: null,
                password: "",
                jenisBarang: { id: null, name: null },
                merkBarang: { id: null, name: null },
                tipeBarang: null,
                spek: null
            }
            this.$bvModal.show('modal-input-imei')
        },

        submit() {
            if (this.$helper.isNullOrEmpty(this.input.jenisBarang) || this.$helper.isNullOrEmpty(this.input.merkBarang) ||
                this.$helper.isNullOrEmpty(this.input.tipeBarang) || this.$helper.isNullOrEmpty(this.input.spek) || this.$helper.isNullOrEmpty(this.input.noImei)
            ) {
                this.$helper.toastErr(this, "Mohon lengkapi data terlebih dahulu!")
                return
            }
            this.loading = true
            this.$axios.post("imei-database/" + `?tipeId=${this.input.tipeBarang.id}&spek=${this.input.spek}&imei=${this.input.noImei}`, { timeout: 300000 }).then(() => {
                this.input.noImei = ''
                this.input.jenisBarang = { id: null, name: null }

                this.loading = false
                this.getImei()
                this.$bvModal.hide('modal-input-imei')
                this.$helper.toastSucc(this, "Data Berhasil Ditambahkan")
                this.resetInput()
            })
                .catch(error => {
                    this.$helper.parseError(this, error)
                    this.loading = false
                })
        },

        modalFoto(id) {
            this.loading = true
            this.$axios.get(`imei-database/photos?imeiDatabaseId=${id}`).then(response => {
                this.loading = false
                this.foto = response.data
                this.$bvModal.show('modal-foto')
            })
                .catch(error => {
                    this.$helper.parseError(this, error)
                    this.loading = false
                })
        },
        modalDelete(id) {
            this.activeId = id
            this.$bvModal.show('modal-delete-imei')
        },

        onDelete() {
            this.loading = true
            this.$axios.post(`imei-database/delete/${this.activeId}`).then(() => {
                this.loading = false
                this.getImei()
                this.$bvModal.hide('modal-delete-imei')
                this.$helper.toastSucc(this, "Data Berhasil Dihapus")
                this.resetInput()
            })
                .catch(error => {
                    this.$helper.parseError(this, error)
                    this.loading = false
                })
        },

        resetInput() {
            this.input = {
                noImei: null,
                password: "",
                jenisBarang: { id: null, name: null },
                merkBarang: { id: null, name: null },
                tipeBarang: null,
            }
        },

        onDownloadOrder() {
            this.loading = true
            this.$bvModal.show('modal-download-imei')
            this.$bvModal.hide('modal-confirm-download')
            setTimeout(() => { this.axiosDownloadExcel() }, 500)
        },

        axiosDownloadExcel() {
            this.$axios.get("imei-database/download-excel").then(response => {
                this.filePathDownload = response.data.name
            })
                .catch(error => {
                    console.log(error)
                    console.log(error.response.data.reason)
                    this.$helper.parseError(this, error)
                })
                .finally(() => {
                    this.loading = false
                })
        },

        detail(id) {
            try {
                this.loading = true
                this.$axios.get("imei-database/photos?imeiDatabaseId=" + id).then(async response => {
                    this.dataDetail = {}
                    this.dataDetail.photos = await response.data
                    this.dataDetail.id = id
                    this.loading = false
                    this.$bvModal.show('modal-detail')
                })
            } catch (error) {
                console.error
                this.loading = false
            }
        },
    },

    watch: {
        'input.noImei': function (newVal) {
            this.input.noImei = newVal.replace(/\s/g, '');
        },

        'input.jenisBarang': function (newVal) {
            this.optElekMerk = []
            this.input.merkBarang = { id: null, name: null }

            if (newVal == null) { return }

            if (newVal.id != undefined) {

                this.$axios.get(`barang-merk/jenis/${newVal.id}`).then(response => {
                    this.optElekMerk = response.data
                })
            }
        },

        'input.merkBarang': function (newVal) {

            this.optElekTipe = []
            this.input.tipeBarang = null

            if (newVal.id == undefined) { return }

            if (newVal.id != undefined) {

                this.$axios.get(`barang-tipe-v2/merk/${newVal.id}`).then(response => {
                    this.optElekTipe = response.data.types
                })
            }

        },
    },


    created() {
        this.init()
        if (this.menu.includes('EIR')) {
            this.fields = [
                { key: "tipe", label: "Tipe Barang" },
                { key: "imei", label: "IMEI" },
                { key: "spek", label: "Resmi / LN" },
                { key: "createdAt", label: "Ditambahkan Pada" },
                { key: "action", label: "Aksi" }
            ]
        }
        else {
            this.fields = [
                { key: "tipe", label: "Tipe Barang" },
                { key: "imei", label: "IMEI" },
                { key: "spek", label: "Resmi / LN" },
                { key: "createdAt", label: "Ditambahkan Pada" },
            ]
        }
    }
}
</script>
<style>
.foto-container {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    /* Jarak antar elemen, sesuaikan sesuai kebutuhan */
}

.foto-item {
    flex: 1 1 calc(33.333% - 10px);
    /* Mengatur elemen agar mengambil 1/3 dari lebar baris, dengan margin */
    box-sizing: border-box;
    /* Memastikan padding dan border termasuk dalam ukuran elemen */
}</style>